var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card', {
    staticClass: "mb-8",
    attrs: {
      "outlined": ""
    }
  }, [_c('m-header', {
    staticClass: "mt-3",
    attrs: {
      "title": _vm.$t('snapshot.signRequest.sign.requestDetail.title'),
      "subtitle": _vm.subtitle
    }
  }), _c('v-card-actions', [_c('v-spacer'), [_vm.RequestStatusEnum.DRAFT, _vm.RequestStatusEnum.REQUESTED].includes(_vm.value.status) ? _c('v-btn', {
    staticClass: "mr-1 mb-1",
    attrs: {
      "color": "primary",
      "disabled": _vm.loading || _vm.loadingReject
    },
    on: {
      "click": _vm.openSignSheet
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("snapshot.signRequest.sign.confirm")) + " ")]) : _vm._e()], 1), _c('v-bottom-sheet', {
    attrs: {
      "inset": _vm.$vuetify.breakpoint.lgAndUp,
      "scrollable": "",
      "persistent": ""
    },
    model: {
      value: _vm.isSignSheetOpen,
      callback: function callback($$v) {
        _vm.isSignSheetOpen = $$v;
      },
      expression: "isSignSheetOpen"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "d-flex align-center"
  }, [_c('div', [_c('div', {
    staticClass: "text-h6"
  }, [_vm._v(_vm._s(_vm.$t("snapshot.signRequest.sign.title")))]), _c('div', {
    staticClass: "subtitle-1 grey--text"
  }, [_vm._v(_vm._s(_vm.$t("snapshot.signRequest.sign.subtitle")))])]), _c('v-spacer')], 1), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('snapshot.signRequest.sign.firstName'),
      "rules": _vm.requiredRule
    },
    model: {
      value: _vm.signature.firstName,
      callback: function callback($$v) {
        _vm.$set(_vm.signature, "firstName", $$v);
      },
      expression: "signature.firstName"
    }
  }), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('snapshot.signRequest.sign.lastName'),
      "rules": _vm.requiredRule
    },
    model: {
      value: _vm.signature.lastName,
      callback: function callback($$v) {
        _vm.$set(_vm.signature, "lastName", $$v);
      },
      expression: "signature.lastName"
    }
  }), _c('v-text-field', {
    attrs: {
      "outlined": "",
      "label": _vm.$t('snapshot.signRequest.sign.location'),
      "rules": _vm.requiredRule
    },
    model: {
      value: _vm.signature.location,
      callback: function callback($$v) {
        _vm.$set(_vm.signature, "location", $$v);
      },
      expression: "signature.location"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('div', {
    staticClass: "mx-auto",
    style: _vm.widthStyle
  }, [_c('div', {
    style: "height: ".concat(_vm.heightSignature, "; ").concat(_vm.widthStyle, ";")
  }, [_c('span', {
    staticClass: "overlay",
    staticStyle: {
      "z-index": "1"
    },
    style: _vm.overlayStyle
  }, [_vm._v(" " + _vm._s(_vm.$t("snapshot.signRequest.sign.signOverlay")) + " ")]), _c('vue-signature-pad', {
    key: "i-am-a-frustrating-pad-and-only-work-when-this-frigging-key-switches-".concat(_vm.signPadMotivationalKey),
    ref: "signaturePad",
    attrs: {
      "id": "signature",
      "options": {
        onBegin: _vm.onBegin
      }
    }
  }), _c('span', {
    staticClass: "signLine unselectable"
  })], 1), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "pt-1"
  }, [_vm._v(" " + _vm._s(_vm.locationText) + " ")]), _c('v-spacer'), _c('v-tooltip', {
    attrs: {
      "left": "",
      "nudge-left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          staticClass: "mr-6",
          attrs: {
            "small": "",
            "icon": ""
          },
          on: {
            "click": _vm.clear
          }
        }, on), [_c('v-icon', [_vm._v(" mdi-redo-variant ")])], 1)];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("snapshot.signRequest.sign.clear")))])])], 1)])])], 1), _c('v-checkbox', {
    ref: "terms",
    attrs: {
      "dense": "",
      "label": _vm.$t('snapshot.signRequest.sign.readTerms'),
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE),
      "data-test-terms-checkbox": ""
    },
    model: {
      value: _vm.terms,
      callback: function callback($$v) {
        _vm.terms = $$v;
      },
      expression: "terms"
    }
  })], 1), _c('v-row', [_c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "text": "",
      "large": ""
    },
    on: {
      "click": _vm.closeSignSheet
    }
  }, [_vm._v(_vm._s(_vm.$t("snapshot.signRequest.sign.back")))]), _c('v-spacer'), _c('v-btn', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "color": "primary",
      "large": "",
      "loading": _vm.loading,
      "disabled": !_vm.isValid || _vm.loading || !_vm.isSigned
    },
    on: {
      "click": _vm.confirmSign
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("snapshot.signRequest.sign.confirm")) + " ")])], 1)], 1)], 1)], 1)], 1)], 1), _vm.value && _vm.value.snapshot ? _c('snapshot-detail', {
    key: 'snapshot-detail-response' + _vm.snapshotDetailResponseKey,
    attrs: {
      "value": _vm.value.snapshot,
      "hideBreadCrumbs": true,
      "hideToDetailButton": true,
      "hideShareButton": true,
      "hideChips": true,
      "hideSignButton": true,
      "outline": true,
      "hideSignatureRequests": true
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }